<template>
  <div class="form__image">
    <label class="form__label" for="image">Imagen</label>
    <img :src="cover" alt="Inventory Image" class="form__thumb">
    <button class="btn btn__action btn--small" @click.prevent="showMedia = true">Cargar Imagen</button>
    <button v-if="cover" class="btn btn__transparent btn--small" @click.prevent="removeImage">Quitar Imagen</button>
    <media-popup @close="showMedia = false" v-if="showMedia" field="cover"></media-popup>
  </div>
</template>

<script>
import mediaPopup from '@/components/media/popup'
import {config} from '@/core/config/base'
export default {
  props: {
    value: {
      required: true,
      type: Object,
      default: function () {
        return {
          id: null,
          name: null,
          path: null,
          sizes: null
        }
      }
    }
  },
  components: {mediaPopup},
  data: function () {
    return {
      showMedia: false,
      newImage: false,
      img: null,
      cover: null
    }
  },
  created: function () {
    this.setImage(this.value)
  },
  mounted: function () {
    this.$on('cover', media => {
      this.cover = config.statics.url + media.image.sizes.small
      this.img = media.image
    })
  },
  watch: {
    img: {
      handler: function () {
        this.setImage(this.img)
        this.$emit('input', this.img)
      },
      deep: true
    },
  },
  methods: {
    setImage: function (image) {
      if (image.sizes !== undefined) {
        this.cover = config.statics.url + image.sizes.small
      } else {
        this.cover = config.statics.dummy
      }
    },
    removeImage: function () {
      this.cover = null
      this.img = null
      this.$emit('remove')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inventory/image.vue